import { RecordUsageRes } from '../../redux/recordUsage/recordUsageApiSlice';

export interface CommonEcwComponentProps {
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface EcwFormValues {
    patID: string;
    barcode: string;
    qty: number;
    units: string;
    waste: number;
    accessKey?: string,
    patFName?: string,
    patMName?: string,
    patLName?: string,
    patDOB?: string,
    patGender?: string,
    userID?: string,
    userFName?: string,
    userMName?: string,
    userLName?: string,
    userNum?: string,
    hcpid?: string,
    hcpfName?: string,
    hcpmName?: string,
    hcplName?: string,
    hcpNum?: string,
    serverDate?: string,
    serverTime?: string,
    location?: string,
    query?: string,
    uniqueId?: string,
    inventory?: boolean,
    expiringInventory?: boolean,
    emrOrderId?: string,
    name?: string,
    encounterId?: string,
    encounterDate?: string,
    emrOrderDate?: string,
    reason?: string | null,
    clientId?: string,
    orderId: string | number;
    orderType: string;
    route: string;
    site: string;
    facilityGuid?: string,
    facilityName?: string,
    itemInfo: {
        lotNumber?: string,
        expiration?: string,
        ndcCode?: string,
        manufacturer?: string,
        cvXCode?: string,
        mvxCode?: string,
        mvxManufacturer?: string,
        stock?: string,
        itemName?: string,
        itemType?: string,
    }
}

export const EcwFormInitialValues: EcwFormValues = {
    patID: "",
    barcode: "",
    qty: 0,
    units: "",
    waste: 0,
    accessKey: "",
    patFName: "",
    patMName: "",
    patLName: "",
    patDOB: "",
    patGender: "",
    userID: "",
    userFName: "",
    userMName: "",
    userLName: "",
    userNum: "",
    hcpid: "",
    hcpfName: "",
    hcpmName: "",
    hcplName: "",
    hcpNum: "",
    serverDate: "",
    serverTime: "",
    location: "",
    query: "",
    uniqueId: "",
    inventory: true,
    expiringInventory: true,
    emrOrderId: "",
    name: "",
    encounterId: "",
    encounterDate: "",
    emrOrderDate: "",
    reason: null,
    clientId: "",
    orderId: "",
    orderType: "",
    route: "",
    site: "",
    facilityGuid: "",
    facilityName: "",
    itemInfo: {
        lotNumber: "",
        expiration: "",
        ndcCode: "",
        manufacturer: "",
        cvXCode: "",
        mvxCode: "",
        mvxManufacturer: "",
        stock: "",
        itemName: "",
        itemType: "",
    }
}

export const AddPatientFormInitialValues = {
    firstName: "",
    lastName: "",
    dob: null as Date | null,
    gender: "",
    patientCode: "",
    isActive: true,
}

export const genderOptions: string[] = ["Male", "Female", "Other"];

export const OrderTypeOptions: { value: string, label: string }[] = [
    { value: "VAC", label: "Vaccine" },
    { value: "MED", label: "Medication" },
    { value: "THINJ", label: "Therapeutic injection" },
    { value: "DME", label: "DME" }
];

export const RouteFieldOptions = [
    { value: "", label: "Please select route" },
    { value: "ID", label: "Intradermal" },
    { value: "IM", label: "Intramuscular" },
    { value: "NS", label: "Nasal" },
    { value: "IV", label: "Intravenous" },
    { value: "PO", label: "Oral" },
    { value: "OTH", label: "Other/Miscellaneous" },
    { value: "SC", label: "Subcutaneous" },
    { value: "TD", label: "Transdermal" },
    { value: "NA", label: "NA" }
]

export const RouteFieldOptionsThinj = [
    { value: "", label: "Please select route" },
    { value: "IDINJ", label: "Intradermal" },
    { value: "IM", label: "Intramuscular" },
    { value: "NASINHLC", label: "Nasal" },
    { value: "IVINJ", label: "Intravenous" },
    { value: "PO", label: "Oral" },
    { value: "SQ", label: "Subcutaneous" },
    { value: "TRNSDERM", label: "Transdermal" }
]

export const SiteFieldOptions = [
    { value: "", label: "Please select site" },
    { value: "BN", label: "Bilateral Nares" },
    { value: "LA", label: "Left Arm" },
    { value: "LD", label: "Left Deltoid" },
    { value: "LG", label: "Left Gluteus Medius" },
    { value: "LLFA", label: "Left Lower Forearm" },
    { value: "LN", label: "Left Nares" },
    { value: "LPC", label: "Left Posterior Chest" },
    { value: "LT", label: "Left Thigh" },
    { value: "LVL", label: "Left Vastus Lateralis" },
    { value: "RA", label: "Right Arm" },
    { value: "RD", label: "Right Deltoid" },
    { value: "RG", label: "Right Gluteus Medius" },
    { value: "RLFA", label: "Right Lower Forearm" },
    { value: "RN", label: "Right Nares" },
    { value: "RPC", label: "Right Posterior Chest" },
    { value: "RT", label: "Right Thigh" },
    { value: "RVL", label: "Right Vastus Lateralis" },
    { value: "NA", label: "NA" }
]
export interface EcwOrdersResponse {
    patientMRN?: string;
    firstName?: string;
    lastName?: string;
    gender?: string;
    birthDate?: string;
    orders?: EcwOrder[];
}

export interface EcwOrder {
    facility: {
        facilityId: string;
        facilityName: string;
    };
    loggedUser: {
        lastName: string;
        firstName: string;
        username: string;
    };
    doses: string;
    cvxCode: string;
    provider: {
        npi: string;
        lastName: string;
        firstName: string;
    };
    vfcCode: string;
    encounterDate: string;
    emrJsonId: number;
    encounterId: number;
    vaccineName: string;
    immId: number;
    status: string;
    colour: string;
    ecwResponseMessage?: string | null;
    isSuccess?: boolean | null;
    orderType?: string | null;
    id?: string;
    medicationRequest?: {
        fhirId: string;
        intent: string;
        authoredOn: string;
        dosageInstruction: string;
        rxOrderNo: string;
        additionalInstruction: string;
        timingStart: string;
        timingCode: string;
        route: string;
        dosage: number;
        dosageUnit: string;
        medicationId: string | null;
        medicationName: string;
        ndcCode: string;
        rxNormCode: string;
        ecwOrderId: string;
        ecwOrder: any;
        id: string;
        isActive: boolean;
        createdOnUtc: string;
        updatedOnUtc: string | null;
        createdBy: string;
        updatedBy: string | null;
    };
    medicationAdministration?: {
        fhirId?: string;
        effectiveDateTime?: string;
        medicationType?: string;
        patientDoseNumber?: number;
        route?: string;
        site?: string;
        method?: string;
        dosage?: number;
        dosageUnit?: string;
        lotNumber?: string;
        medicationName?: string;
        medicationCode?: string;
        medicationCodeSystem?: string;
        ecwOrderId?: string;
        id?: string;
        isActive?: boolean;
        createdOnUtc?: string;
        updatedOnUtc?: string | null;
        createdBy?: string;
        updatedBy?: string | null;
        status?: string;
    };
}

export interface EcwOrderResponse {
    isOrderProcessed: boolean;
    ecwResponseMessage: string | null;
}

export interface RecordApiMessages {
    success: string;
    error: string[];
}

export const displayInfo = (value: unknown): string => {
    const text = value == null ? "" : String(value).trim();
    return text || "-";
};

export const getOrderIdDisplay = (order: EcwOrder | null | undefined): string => {
    if (!order) return "";
    if (order?.orderType === 'THINJ' && order?.medicationAdministration) {
        const adminOrderId = order.medicationAdministration?.fhirId;
        if (adminOrderId) {
            return `MA-${adminOrderId.slice(-5)}`;
        }
    }
    const key = getOrderKey(order);
    return key !== undefined && key !== null ? String(key) : "";
};

export const getOrderKey = (order: EcwOrder | null | undefined): string | number | undefined =>
    order?.immId || order?.medicationRequest?.rxOrderNo || order?.medicationAdministration?.fhirId;

export const getRevisedSiteRouteValue = (field: 'site' | 'route', orderType: string, currentValue: string): string => {
    if (orderType !== 'MED') return currentValue;
    const siteLabelMap = new Map(SiteFieldOptions.map(({ value, label }) => [value, label]));
    const routeLabelMap = new Map(RouteFieldOptions.map(({ value, label }) => [value, label]));

    const label = (field === 'site' ? siteLabelMap : routeLabelMap).get(currentValue);

    return label && label !== currentValue ? `${currentValue} (${label})` : currentValue;
};

type Option = { label?: string; value?: string };

export const findMatchedOption = <T extends Option>(value: string | undefined, options: T[]): T | undefined => {
    const target = value?.toLowerCase();
    if (!target) return undefined;

    return options.find((item) => item?.label?.toLowerCase() === target || item?.value?.toLowerCase() === target);
};

export const getSiteDetails = (siteValue?: string) => {
    const matched = findMatchedOption(siteValue, SiteFieldOptions);
    return {
        siteCode: matched?.value ?? siteValue ?? "",
        siteName: (matched && matched.value) ? (matched.label ?? "") : (siteValue ?? ""),
    };
};

export const getRouteDetails = (routeValue?: string, orderType?: string) => {
    const routeOptions = orderType === "THINJ" ? RouteFieldOptionsThinj : RouteFieldOptions;
    const matched = findMatchedOption(routeValue, routeOptions)
        || findMatchedOption(routeValue, RouteFieldOptions)
        || findMatchedOption(routeValue, RouteFieldOptionsThinj);

    return {
        routeCode: matched?.value ?? routeValue ?? "",
        routeName: (matched && matched.value) ? (matched.label ?? "") : (routeValue ?? ""),
    };
};

export interface SelectUnitOption {
    value: string;
    label: string;
    isDefault: boolean;
}

export type OrderConfirmationStatus = "pending" | "confirmed" | "cancelled";

export interface OrderConfirmationState {
    orderKey: string | number | null;
    status: OrderConfirmationStatus;
}

export interface BarcodeMismatchItem {
    field: string;
    orderValue: string;
    barcodeValue: string;
}

export const normalizeLotOrUnit = (val?: string | null): string => {
    return val ? val.trim().toLowerCase() : "";
};

export const normalizeNdc = (val?: string | null): string => {
    return val ? val.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() : "";
};

export const checkBarcodeMismatches = (
    orderMedAdmin: EcwOrder["medicationAdministration"] | undefined,
    barcodeData: RecordUsageRes | null | undefined
): BarcodeMismatchItem[] => {
    if (!orderMedAdmin || !barcodeData) return [];

    const mismatches: BarcodeMismatchItem[] = [];

    // 1. Lot number: compare only if order has a value
    const orderLot = orderMedAdmin.lotNumber?.trim();
    if (orderLot) {
        const barcodeLot = barcodeData.lotNo?.trim() ?? "";
        if (normalizeLotOrUnit(orderLot) !== normalizeLotOrUnit(barcodeLot)) {
            mismatches.push({
                field: "Lot Number",
                orderValue: orderLot,
                barcodeValue: barcodeLot || "-",
            });
        }
    }

    // 2. NDC: compare only if order has a value
    const orderCode = orderMedAdmin.medicationCode?.trim();
    if (orderCode) {
        const normalizedOrderCode = normalizeNdc(orderCode);
        const barcodeNdc = barcodeData.ndc ?? "";
        const barcodeNdc11 = barcodeData.ndC11 ?? "";
        const normalizedBarcodeNdc = normalizeNdc(barcodeNdc);
        const normalizedBarcodeNdc11 = normalizeNdc(barcodeNdc11);

        const isMatch =
            (normalizedBarcodeNdc11 !== "" && normalizedOrderCode === normalizedBarcodeNdc11) ||
            (normalizedBarcodeNdc !== "" && normalizedOrderCode === normalizedBarcodeNdc);

        if (!isMatch) {
            const barcodeDisplay = barcodeNdc11 || barcodeNdc || "-";
            mismatches.push({
                field: "NDC (Medication Code)",
                orderValue: orderCode,
                barcodeValue: barcodeDisplay,
            });
        }
    }

    // 3. Unit: compare only if order has a value
    const orderUnit = orderMedAdmin.dosageUnit?.trim();
    if (orderUnit) {
        const normalizedOrderUnit = normalizeLotOrUnit(orderUnit);
        const unitsList = barcodeData.useUnits ?? [];
        const isUnitInList = unitsList.some(
            (u) => normalizeLotOrUnit(u?.unitName) === normalizedOrderUnit
        );

        if (!isUnitInList) {
            const availableUnits = unitsList
                .map((u) => u?.unitName)
                .filter(Boolean)
                .join(", ");
            mismatches.push({
                field: "Unit",
                orderValue: orderUnit,
                barcodeValue: availableUnits || "-",
            });
        }
    }

    return mismatches;
};
